<template>
    <div class="calendar-free-container">
        <div class="calendar-free-text">
            {{ dragging ? $t('routines.create_new') : $t('common.free') }}
            <div class="text-right pr-1">
                <button-tooltip @click="$emit('click:add_block')" fab depressed color="#F9F9F9" height="30" width="30"
                    :tooltip="$t('tooltips.add_block')">
                    <v-icon size="13" color="#078571">mdi-code-brackets</v-icon>
                </button-tooltip>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonTooltip from '../common/ButtonTooltip.vue'
export default {
    components: { ButtonTooltip },
    name: "NoRoutinesInDate",
    props: {
        dragging: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>
.calendar-free-container {
    position: relative;
    min-height: 80px;
}

.calendar-free-text {
    width: 90%;
    text-align: center;
    font-weight: 300;
    font-size: 12px;
    line-height: 12px;
    color: #03342C;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>